/* eslint-disable react/prop-types */

import React from 'react';
import styled from 'styled-components';

import ButtonIcon from '@ntuctech/devex-tangram/Button/ButtonIcon';
import SvgArrowLeft from '@ntuctech/devex-tangram/Icon/SvgArrowLeft';

const StyledButtonIcon = styled(ButtonIcon)`
  position: absolute;
  top: -5rem;
  left: 2.5rem;

  &._ndsBtn--large {
    max-width: 3rem;
    width: 3rem;
    max-height: 3rem;
    height: 3rem;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2);
  }
`;

const BackButtonDesktop = ({ action }) => (
  <StyledButtonIcon
    className="ndsHidden-s-down"
    compact
    size="l"
    onClick={action}
    data-testid="goBackButtonDesktop"
  >
    <SvgArrowLeft color="#6734a2" />
  </StyledButtonIcon>
);

export default BackButtonDesktop;
